<div class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Monitor de evaluaciones de riesgo</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <div class="content-card dash-panel" >

            <!-- / CONTENT TOOLBAR -->




            <div class="widget-group" fxLayout="row wrap" fxFlex="100" *fuseIfOnDom
                 [@animateStagger]="{value:'50'}">

                 <div class=" m-20" fxFlex="100" fxFlex.gt-md="65" fxLayout="column">
                   <div >
                     <!-- CONTENT -->
                     <div class="content">

                       <!-- WIDGET 1 -->
                       <div class="fuse-widget-front " fxFlex.gt-md="25">
                           <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                               <div class="font-size-50 line-height-50 ">
                                   {{preiniciadas}}
                               </div>
                               <div class="h3 secondary-text font-weight-500 ">Pre Iniciadas
                               </div>
                           </div>
                       </div>
                       <!-- / WIDGET 1 -->

                       <div class="fuse-widget-front " fxFlex.gt-md="25">
                           <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                               <div class="red-fg font-size-50 line-height-50 ">
                                   {{iniciadas}}
                               </div>
                               <div class="h3 secondary-text font-weight-500 ">Iniciadas
                               </div>
                           </div>
                       </div>

                       <div class="fuse-widget-front " fxFlex.gt-md="25">
                           <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                               <div class="yellow-fg font-size-50 line-height-50 ">
                                   {{completadas}}
                               </div>
                               <div class="h3 secondary-text font-weight-500 ">Completadas
                               </div>

                           </div>
                       </div>

                       <div class="fuse-widget-front " fxFlex.gt-md="25">
                           <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                               <div class="orange-fg font-size-50 line-height-50 ">
                                   {{aprobadas}}
                               </div>
                               <div class="h3 secondary-text font-weight-500 ">Aprobadas
                               </div>

                           </div>
                       </div>

                       <div class="fuse-widget-front " fxFlex.gt-md="25">
                           <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                               <div class="green-fg font-size-50 line-height-50 ">
                                   {{cerradas}}
                               </div>
                               <div class="h3 secondary-text font-weight-500 ">Cerradas
                               </div>

                           </div>
                       </div>


                     </div>
                     <!-- / CONTENT -->

                   </div>

                  <div class="fuse-card auto-width " fxFlex="100" >
                  <!-- WIDGET 8 -->
                    <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget table-scroll-container" fxLayout="column" fxFlex="100" >

                                 <div class="h3 px-16 py-24">
                                     Evaluaciones pendientes de revisión
                                 </div>

                                 <mat-divider></mat-divider>

                                 <!-- CONTENT -->
                                 <div class="content p-24 scroll-table-container">

                                   <table mat-table [dataSource]="dataSource" #mytable class="my-table mat-elevation-z8">
                                     <!-- User Column -->
                                     <ng-container matColumnDef="nombre">
                                       <th mat-header-cell *matHeaderCellDef> Nombre </th>
                                       <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                                     </ng-container>

                                     <ng-container matColumnDef="version">
                                       <th mat-header-cell *matHeaderCellDef> Versión </th>
                                       <td mat-cell *matCellDef="let element"> {{element.version}} </td>
                                     </ng-container>

                                     <ng-container matColumnDef="dueno">
                                       <th mat-header-cell *matHeaderCellDef> Dueño </th>
                                       <td mat-cell *matCellDef="let element"> {{element.owner.nombreCompleto}} </td>
                                     </ng-container>

                                     <ng-container matColumnDef="fechaInicio">
                                       <th mat-header-cell *matHeaderCellDef> Fecha de inicio </th>
                                       <td mat-cell *matCellDef="let element"> {{element.fechaInicio | date:'dd/MM/yyyy'}} </td>
                                     </ng-container>

                                     <ng-container matColumnDef="fechaFin">
                                       <th mat-header-cell *matHeaderCellDef> Fecha de finalización </th>
                                       <td mat-cell *matCellDef="let element"> {{element.fechaFin | date:'dd/MM/yyyy'}} </td>
                                     </ng-container>

                                     <ng-container matColumnDef="ver">
                                       <th mat-header-cell *matHeaderCellDef> Acción </th>
                                       <td mat-cell *matCellDef="let element" class="action-link">
                                         <a  (click)="navegateTo('/evaluacion',element.id)" >Ver</a>
                                       </td>
                                     </ng-container>


                                     <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                     <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                   </table>

                                 </div>
                                 <!-- / CONTENT -->

                    </fuse-widget>
                    <!-- / WIDGET 8 -->
                  </div>
                </div>

                <!-- WIDGET 9 -->
                <fuse-widget [@animate]="{value:'*',params:{y:'100%'}}" class="widget" fxLayout="column"
                             fxFlex="100" fxFlex.gt-md="30">


                       <div class="fuse-card auto-width p-16 ng-tns-c309-31 m-20" >
                       <!-- WIDGET 1 -->
                         <fuse-widget  class="widget" fxLayout="column">

                           <!-- Front -->
                           <div class="fuse-widget-front">

                               <div class="h-300">
                                   <ngx-charts-pie-chart
                                       *fuseIfOnDom
                                       [scheme]="widget8.scheme"
                                       [customColors]="customColors"
                                       [results]="mainChart"
                                       [legend]="widget8.legend"
                                       [explodeSlices]="widget8.explodeSlices"
                                       [labels]="widget8.labels"
                                       [doughnut]="widget8.doughnut"
                                       [gradient]="widget8.gradient"
                                       (select)="widget8.onSelect($event)">
                                   </ngx-charts-pie-chart>
                               </div>

                           </div>
                           <!-- / Front -->

                         </fuse-widget>
                        </div>

                        <div class="fuse-card auto-width p-16 ng-tns-c309-31 m-20" >
                        <!-- WIDGET 1 -->
                          <fuse-widget  class="widget" fxLayout="column">

                            <!-- Front -->
                            <div class="fuse-widget-front">

                                <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                                    <div class="h1 pr-16">Cronograma</div>
                                </div>

                                <table class="simple clickable">
                                    <thead>
                                        <tr>
                                            <th class="text-right"></th>
                                            <th class="text-right">Cantidad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                          <td class="text-right tag">
                                            <div fxLayout="row">
                                              <div class="tag-color" style="background-color: #f44336;"></div>
                                              <div>Atrasadas</div>
                                            </div>
                                          </td>
                                            <td class="text-right">{{atrasadas}}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-right tag">
                                              <div fxLayout="row">
                                                <div class="tag-color" style="background-color: #ff9800;"></div>
                                                <div>Vencen hoy</div>
                                              </div>
                                            </td>
                                            <td class="text-right">{{vencenHoy}}</td>
                                        </tr>
                                        <tr>
                                          <td class="text-right tag">
                                            <div fxLayout="row">
                                              <div class="tag-color" style="background-color: rgb(56, 142, 60);"></div>
                                              <div >En Fecha</div>
                                            </div>
                                          </td>
                                            <td class="text-right">{{enFecha}}</td>
                                        </tr>
                                    </tbody>
                                </table>


                            </div>
                          </fuse-widget>

                        </div>
                        <!-- / widget 9 -->


                </fuse-widget>
                <!-- / WIDGET 9 -->



            </div>

        </div>



    </div>
    <!-- / CENTER -->

</div>
